module.exports = __webpack_public_path__ + "img/splashLogo.428e2fa0.png";